import React from 'react';
import { motion } from 'framer-motion';
import { Scale } from 'lucide-react';
export function CostOfInactionSection() {
  const costs = [{
    sin: 'Tutoriales sin sistema',
    costo: 'Tiempo perdido sin resultado'
  }, {
    sin: 'Sin mail profesional',
    costo: 'Clientes que no confían'
  }, {
    sin: 'Sin Excel funcional',
    costo: 'Oportunidades que se escapan'
  }, {
    sin: 'Sin contrato ni cobro',
    costo: 'Trabajo gratis o impago'
  }, {
    sin: 'Sin imagen en videollamadas',
    costo: 'Primera impresión que juega en contra'
  }];
  return <section className="bg-night py-12" data-id="element-46">
      <div className="max-w-4xl mx-auto px-6" data-id="element-47">
        <div className="text-center mb-8" data-id="element-48">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 flex items-center justify-center gap-3" data-id="element-49">
            <Scale className="w-8 h-8 text-gold-accent" data-id="element-50" />
            EL COSTO DE NO TENERLO
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="glass rounded-2xl overflow-hidden mb-8" data-id="element-51">
          <table className="w-full text-left border-collapse" data-id="element-52">
            <thead data-id="element-53">
              <tr data-id="element-54">
                <th className="bg-white/5 p-5 font-bold text-white border-b border-white/10 w-1/2" data-id="element-55">
                  Sin la Colección
                </th>
                <th className="bg-red-500/10 p-5 font-bold text-red-400 border-b border-white/10 w-1/2" data-id="element-56">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/10" data-id="element-57">
              {costs.map((row, idx) => <tr key={idx} className="hover:bg-white/5 transition-colors" data-id="element-58">
                  <td className="p-5 text-textLight" data-id="element-59">{row.sin}</td>
                  <td className="p-5 text-red-400 font-medium" data-id="element-60">{row.costo}</td>
                </tr>)}
            </tbody>
          </table>
        </motion.div>

        <div className="text-center" data-id="element-61">
          <p className="text-2xl font-bold text-gold-accent" data-id="element-62">
            Tu próximo cliente puede llegar antes de lo que creés. 💪
          </p>
        </div>
      </div>
    </section>;
}